import { useLocation } from 'react-router-dom';

import { QueryObject } from 'bernie-core';

import { parse } from 'query-string';

export const useQueryParams = (): QueryObject => {
  const location = useLocation();

  return parse(location.search);
};
